import { Action, Dispatch } from 'redux'
import { push } from 'connected-react-router'
import { db, FirebaseTimestamp } from 'firebase/index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { Item } from 'types/dnd'

const saveBreadsOrder = (items: Item[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const batch = db.batch()
    const now = FirebaseTimestamp.now()
    for (let i = 0; i < items.length; i = (i + 1) | 0) {
      const item = items[i]
      if (!item.bread.bread_ref) continue
      const ref = item.bread.bread_ref
      delete item.bread.bread_ref
      item.bread.order = i + 1
      item.bread.updated_at = now
      batch.set(ref, item.bread, { merge: true })
    }
    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push('/product/order/complete'))
      })
      .catch((error) => {
        dispatch(hideLoadingAction())
        console.error(error)
      })
  }
}

export default saveBreadsOrder
